import React from 'react'
import PropTypes from 'prop-types'

export const ReportsContext = React.createContext()
export const ReportsContextProvider = (props) => {
  const [inboundAudio, setInboundAudio] = React.useState(null)
  const [outboundAudio, setoutboundAudio] = React.useState(null)
  const [inboundVideo, setInboundVideo] = React.useState(null)
  const [outboundVideo, setOutboundVideo] = React.useState(null)
  return (
    <ReportsContext.Provider
      value={{
        inboundAudio,
        setInboundAudio,
        outboundAudio,
        setoutboundAudio,
        inboundVideo,
        setInboundVideo,
        outboundVideo,
        setOutboundVideo
      }}
    >
      {props.children}
    </ReportsContext.Provider>
  )
}

ReportsContextProvider.propTypes = {
  children: PropTypes.array
}
